import { Injectable } from '@angular/core';
import { RestDeviceService } from 'src/app/service/rest/device/rest-device.service';
import { MaintenanceHistory } from '../maintenance/maintenance.model';
import { InstallationHistory } from '../procedure/procedure.model';
import { HistoryType } from './device.model';

@Injectable()
export class DeviceHistoryService {

  private _maintenanceHistory: MaintenanceHistory;
  private _installationHistory: InstallationHistory;

  private _historyType: HistoryType;

  constructor(private restDevice : RestDeviceService) { }

  public get maintenanceHistory(): MaintenanceHistory {
    return this._maintenanceHistory;
  }
  public set maintenanceHistory(value: MaintenanceHistory) {
    this._maintenanceHistory = value;
  }

  public get installationHistory(): InstallationHistory {
    return this._installationHistory;
  }
  public set installationHistory(value: InstallationHistory) {
    this._installationHistory = value;
  }

  public get historyType(): HistoryType {
    return this._historyType;
  }
  public set historyType(value: HistoryType) {
    this._historyType = value;
  }

  getMaintenanceHistoryById(id : number){
    this.restDevice.getDeviceMaintenanceHistoryById(id)
      .subscribe((result: MaintenanceHistory) => {
        this.maintenanceHistory = result;
      })
  }

  getInstallationHistoryById(id: number) {
    this.restDevice.getDeviceInstallationHistoryById(id)
      .subscribe((result: InstallationHistory) => {
        console.log(result);
        this.installationHistory = result;
      })
  }
}
